/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from rtu-ui-v2/schemas/common/ActionBarConfiguration.yaml
import { RoundButton } from './Common';
/**
Configuration of the buttons available in the action bar.
*/
export class ActionBarConfiguration {
    /** @param source {@displayType `DeepPartial<ActionBarConfiguration>`} */
    constructor(source = {}) {
        /**
          Configuration of the 'flash' button.
          */
        this.flashButton = new RoundButton({
            visible: true,
            accessibilityDescription: '?accessibilityDescriptionFlashButton',
            backgroundColor: '?sbColorSurfaceHigh',
            foregroundColor: '?sbColorOnPrimary',
            activeBackgroundColor: '?sbColorWarning',
            activeForegroundColor: '#1C1B1F',
        });
        /**
          Configuration of the 'zoom' button.
          */
        this.zoomButton = new RoundButton({
            visible: true,
            accessibilityDescription: '?accessibilityDescriptionZoomButton',
            backgroundColor: '?sbColorSurfaceHigh',
            foregroundColor: '?sbColorOnPrimary',
            activeBackgroundColor: '?sbColorSurfaceHigh',
            activeForegroundColor: '?sbColorOnPrimary',
        });
        /**
          Configuration of the 'flip camera' button.
          */
        this.flipCameraButton = new RoundButton({
            visible: true,
            accessibilityDescription: '?accessibilityDescriptionFlipCameraButton',
            backgroundColor: '?sbColorSurfaceHigh',
            foregroundColor: '?sbColorOnPrimary',
            activeBackgroundColor: '?sbColorWarning',
            activeForegroundColor: '#1C1B1F',
        });
        if (source.flashButton !== undefined) {
            this.flashButton = new RoundButton(source.flashButton);
        }
        if (source.zoomButton !== undefined) {
            this.zoomButton = new RoundButton(source.zoomButton);
        }
        if (source.flipCameraButton !== undefined) {
            this.flipCameraButton = new RoundButton(source.flipCameraButton);
        }
    }
}
//# sourceMappingURL=ActionBarConfiguration.js.map